import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { TaxGroup } from '@app/models';
import { ActivityService, NAS_API_CONFIG } from '@nittenapps/api';
import { snakeToCamel } from '@nittenapps/common';
import { EMPTY, map, mergeMap, of } from 'rxjs';

export const taxGroupResolver: ResolveFn<TaxGroup> = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const id = route.paramMap.get('id')!;
  const activity = snakeToCamel(route.parent!.url[0].path?.replaceAll('-', '_'));
  const activityService = new ActivityService(inject(NAS_API_CONFIG), inject(HttpClient), activity);

  if (!activity) {
    return EMPTY;
  }

  if (id === '__NEW__') {
    return {};
  }

  return activityService.getObject(id).pipe(
    map((response) => response.body.object),
    mergeMap((taxGroup) => {
      if (taxGroup) {
        return of(taxGroup);
      }
      router.navigate(['..']);
      return EMPTY;
    }),
  );
};
